import * as constants from "./constants"
import * as components from "./components"
import * as containers from "./containers"
import reducer from "./reducer"

const content = { components, constants, reducer, containers }
export default content
export const { OrganizationBlankSlate } = containers
export const { OrganizationDetail } = components
